import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import GroupIcon from "@material-ui/icons/Group";
import DevicesRoundedIcon from "@material-ui/icons/DevicesRounded";
import DynamicFeedRoundedIcon from "@material-ui/icons/DynamicFeedRounded";
import { ROUTES_DEVICES, ROUTES_SESSIONS, ROUTES_USERS } from "../../../utils/constants";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import AboutTextComponent from "../../../i18n/about";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: theme.spacing(4, 2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  title: {
    textTransform: "upperCase",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  button: theme.classes.mainButton,
  linkBlock: {
    display: "flex",
    justifyContent: "center",
  },
  textContainer: {
    padding: theme.spacing(0, 4),
  },
}));

const UserManagementInfoComponent = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const intl = useIntl();

  const handleRedirect = (url) => {
    navigate(url);
  };

  return (
    <div className={classes.pageContainer}>
      <Typography variant={"h4"} className={classes.title}>
        {intl.formatMessage({ id: "menu.user_info" })}
      </Typography>
      <Grid container spacing={2} className={classes.content}>
        <Grid item xs={12} sm={12} md={12} lg={3} container>
          <Grid item container xs={12}>
            <Button startIcon={<GroupIcon />} className={classes.button} onClick={() => handleRedirect(ROUTES_USERS)}>
              {intl.formatMessage({ id: "menu.user_list" })}
            </Button>
          </Grid>
          <Grid item container xs={12}>
            <Button
              startIcon={<DevicesRoundedIcon />}
              className={classes.button}
              onClick={() => handleRedirect(ROUTES_DEVICES)}
            >
              {intl.formatMessage({ id: "menu.device_list" })}
            </Button>
          </Grid>
          <Grid item container xs={12}>
            <Button
              startIcon={<DynamicFeedRoundedIcon />}
              className={classes.button}
              onClick={() => handleRedirect(ROUTES_SESSIONS)}
            >
              {intl.formatMessage({ id: "menu.session_list" })}
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={12} sm={12} md={12} lg={8} className={classes.textContainer}>
          <AboutTextComponent />
          {/*<Typography dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "apps.users.about" }, { url: 'https://www.google.com'}) }} />*/}
        </Grid>
      </Grid>
    </div>
  );
};

export default UserManagementInfoComponent;
